import { isPlatformBrowser } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { debounceTime, take } from 'rxjs/operators';
import { SnakBarAlertComponent } from 'src/app/core/components/snak-bar-alert/snak-bar-alert.component';
import { Alert } from 'src/app/core/models/alert.model';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToolBarService } from './toolbar.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit, AfterViewChecked {
  public showLoadingBar: boolean = false;
  public horizontalNav: boolean = false;
  public rol: string = '';
  public searchGeneralControl = new FormControl();
  public alertsCounts: number = 0;

  constructor(
    private router: Router,
    private auth: AuthService,
    private search: ToolBarService,
    private notificationService: NotificationService,
    private snackBar: MatSnackBar,
    private readonly cd: ChangeDetectorRef,
    private readonly cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    try {
      this.notificationService.getNotifications()
      .pipe(take(1))
      .subscribe(data => {
        data.forEach((alert: any) => {
          this.notificationService.addAlert({
            id: alert.id,
            title: alert.title,
            message: alert.message.replaceAll('\n', '<br>'),
            shown: false,
            type: alert.type,
            property_id: alert.property_id,
            user_id: alert.user_to ?? alert.user_id,
            for_id: alert.for_id,
            created_at: alert.created_at,
            advance_id: alert.advance_id,
            read: alert.read == 1
          } as Alert);
        });
      }, _ => {});
    } catch (err) {
      console.log(err); 
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showLoadingBar = true;
      }

      if (event instanceof NavigationEnd) {
        this.showLoadingBar = false;

        if (!this.isAuthenticated) {
          this.notificationService.emtyAlerts();
        }
      }

      this.cd.detectChanges();
    });

    this.rol = this.auth.rolCode;

    this.notificationService.alerts.subscribe((data) => {
      this.alertsCounts = data.filter(item => !item.read && item.for_id == this.auth.idUser).length;
    });
  }

  ngAfterViewChecked(): void {
    this.alertsCounts = this.notificationService.alerts.value.filter(item => !item.read && item.for_id == this.auth.idUser).length;
  }

  ngOnInit(): void {
    this.searchGeneralControl.valueChanges
      .pipe(debounceTime(800))
      .subscribe((value) => {
        this.search.onSearch.next(value);
      });

    this.auth.setInit();
  }

  logAuth(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
      this.router.navigate(['/auth']);
    }
  }

  showMessage(message: string, subMessage: string, type: string): void {

    this.snackBar.openFromComponent(SnakBarAlertComponent, {
      data: {
        message,
        subMessage,
        type,
      },
      panelClass: 'snack-message',
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
    });
  }

  public get username(): string {
    return this.auth.email;
  }

  public get labelRol(): string {
    var label = 'Inquilino';

    switch(this.auth.rolCode) {
      case 'owner':
      case 'both':
          label = 'Propietario';
      break;
      case 'admin':
          label = 'Administrador';
    }

    return label;
  }

  public get rolname(): string {
    return this.auth.labelRol;
  }

  public get isAuthenticated(): boolean {
    return this.auth.isAuthenticated();
  }

  public get twoToken(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return !!localStorage.getItem('token2');
    }

    return false;
  }

  public changeToken(): void {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      const token2 = localStorage.getItem('token2');

      localStorage.setItem('token', token2 ?? '');
      localStorage.setItem('token2', token ?? '');
      this.cookieService.set('token', token2 ?? '');
      this.cookieService.set('token2', token ?? '');

      if (this.labelRol == 'Inquilino') {
        window.location.href = '/mis-pagos';
      } else {
        window.location.href = '/propiedades';
      }
    }
  }
}
